import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import { VxeButton } from 'vxe-pc-ui';
import { computed, reactive, ref, watch } from 'vue';
export default {
  name: 'XButton',
  components: {
    VxeButton
  },
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'button',
      validator: value => ['text', 'button'].includes(value)
    },
    type: {
      type: String,
      default: '',
      validator: value => ['', 'default', 'primary', 'success', 'info', 'warning', 'danger'].includes(value)
    },
    size: {
      type: String,
      default: 'medium',
      validator: value => ['medium', 'small', 'mini'].includes(value)
    },
    name: {
      type: [String, Number],
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    round: {
      type: Boolean,
      default: false
    },
    circle: {
      type: Boolean,
      default: false
    },
    permission: {
      type: String,
      default: ''
    },
    href: {
      type: [String, Object],
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    dropdownClassName: {
      type: String,
      default: ''
    },
    placement: {
      type: String,
      default: 'bottom',
      validator: value => ['top', 'bottom'].includes(value)
    },
    destroyOnClose: {
      type: Boolean,
      default: true
    },
    trigger: {
      type: String,
      Default: 'hover',
      validator: value => ['manual', 'hover', 'click'].includes(value)
    },
    transfer: {
      type: Boolean,
      default: true
    },
    dropdown: {
      type: Array,
      default: () => []
    }
  },
  emits: ['click', 'dropdown-click'],
  setup(props, {
    emit
  }) {
    const dropdownMenus = ref([]);
    const dropdownEvents = reactive({});
    const handleClick = ({
      $event
    }) => {
      emit('click', $event);
    };
    const handleDropdownClick = ({
      name,
      $event
    }) => {
      const item = dropdownEvents[name];
      if (!item) return;
      item.onClick && item.onClick($event);
      emit('dropdown-click', item, $event);
    };
    const routerLink = computed(() => {
      if (!props.href) {
        return null;
      } else if (typeof props.href === 'string') {
        return {
          path: props.href
        };
      } else if (typeof props.href === 'object') {
        return props.href;
      }
      return null;
    });
    watch(() => props.dropdown, val => {
      const events = {};
      const menus = [];
      for (const idx in val) {
        const {
          title,
          icon,
          loading,
          disabled,
          permission,
          onClick
        } = val[idx];
        if (!title) continue;
        const item = {
          name: `dropdown_item_${idx}`,
          title,
          icon,
          loading,
          disabled,
          permission,
          onClick
        };
        menus.push(item);
        if (!!onClick && typeof onClick === 'function') events[item.name] = item;
      }
      for (const k in dropdownEvents) {
        if (Reflect.has(dropdownEvents, k)) Reflect.deleteProperty(dropdownEvents, k);
      }
      Object.assign(dropdownEvents, events);
      dropdownMenus.value = menus;
    }, {
      immediate: true,
      deep: true
    });
    return {
      dropdownMenus,
      handleClick,
      handleDropdownClick,
      routerLink
    };
  }
};